import { Input, Modal, Radio, Table } from "antd"
import { useState } from "react"
import VSpace from "../common/VSpace"
import { useJobsForItem } from "./apiQueries"

export type Props = {
  open: boolean
  itemId: number
  onUpdateJobs: (action: UpdateJobsAction, jobIds: number[]) => void
  onCancel: () => void
  loading: boolean
}

type UpdateJobsAction =
  | 'ALL'
  | 'NONE'
  | 'SOME'

const UpdateJobsModal = ({ open, itemId, onUpdateJobs, onCancel, loading }: Props) => {
  const [updateAction, setUpdateAction] = useState<UpdateJobsAction>('NONE')
  const [selectedJobIds, setSelectedJobIds] = useState<number[]>([])
  const [search, setSearch] = useState('')
  const jobsQuery = useJobsForItem(itemId)
  const jobs = jobsQuery.data ?? []

  const handleSubmit = () => {
    if (updateAction === 'SOME') {
      onUpdateJobs(updateAction, selectedJobIds)
    } else {
      onUpdateJobs(updateAction, jobs.map(x => x.id))
    }
  }

  return <Modal
    title="Update Jobs"
    open={open}
    onOk={handleSubmit}
    onCancel={() => onCancel()}
    confirmLoading={loading}
    width={updateAction === 'SOME' ? 800 : undefined}
  >
    <VSpace>
      <p>This change affects {jobs.length} unsold jobs. Do you want to update the pricing on those jobs?</p>
      <Radio.Group
        value={updateAction}
        onChange={e => setUpdateAction(e.target.value as UpdateJobsAction)}
      >
        <VSpace>
          <Radio value="ALL">Yes, update all unsold jobs</Radio>
          <Radio value="NONE">No, only apply to estimates created from now on.</Radio>
          <Radio value="SOME">Only update specific jobs</Radio>
        </VSpace>
      </Radio.Group>
      {updateAction === 'SOME' &&
        <VSpace size="small">
          <Input.Search value={search} onChange={e => setSearch(e.target.value)} />
          <Table
            dataSource={jobs.filter(x => `${x.no} ${x.name}`.toLowerCase().includes(search.toLowerCase()))}
            size="small"
            scroll={{ y: 200 }}
            pagination={false}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: selectedJobIds,
              onChange: (selectedRowKeys) => setSelectedJobIds(selectedRowKeys as number[])
            }}
            rowKey="id"
            columns={[
              {
                title: 'No.',
                dataIndex: 'no'
              },
              {
                title: 'Name',
                dataIndex: 'name'
              },
              {
                title: 'Customer',
                dataIndex: 'customerName'
              },
              {
                title: 'Sales',
                dataIndex: 'salesPersonName'
              },
            ]}
          />
        </VSpace>
      }
    </VSpace>
  </Modal >
}

export default UpdateJobsModal
